import React from 'react';

import component, {classnames} from './component';
import TopBanner from './TopBanner';
import Link from './Link';
import {HBox, VBox} from './Box';
import {ArrowRight} from './icons';


export default component('EmptyPage', function({content}) {
  return (
    <div className="EmptyPage">
      <TopBanner />
      <div className="EmptyPage--Wrap">
        <HBox isContainer={true} width={1}></HBox>
        <HBox isContainer={true} width={2}>
          {content}
        </HBox>
        <HBox isContainer={true} width={1}></HBox>
      </div>
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/EmptyPage.js